import React, { useContext } from "react";
import { CenterContext } from "../../../Context";


export default function StoppedReason({id}) {
    const { center } = useContext(CenterContext)
    let reason = center.stoppedReasons.find(r=>r._id===id)
    if(!reason) return <>Unknown</>
    return (<>{reason.name}</>)
}